import React from 'react';
import { css } from '@emotion/css';

import { ProductNavigationLinks } from '../productNavigationLinks/ProductNavigationLinks';
import PlusSvg from '../../common/SVGs/PlusSvg';
import { useIntl } from '@/i18n';

const styles = {
  header: css`
    font-size: 40px;
    line-height: 60px;
    @media (max-width: 640px) {
      font-size: 32px;
      line-height: 40px;
    }
  `,
  boldPlus: css`
    position: relative;
    font-weight: 800;
  `,
  plusSvg: css`
    position: absolute;
    height: 60%;
    right: -28%;
    top: -5%;
    width: 35%;
  `,
};

export const HeadArea: React.FC = () => {
  const { t } = useIntl();

  return (
    <>
      <div role='heading' aria-level={1} className='page-head margin-bottom-l'>
        <h1
          className={`vertical-center font-heading-xlarge-regular margin-bottom-none page-head-title ${styles.header}`}
        >
          {t({ id: 'headArea.headline', defaultMessage: 'Mein' })}
          <span className={styles.boldPlus}>
            &nbsp;
            {t({ id: 'headArea.plus', defaultMessage: 'Plus' })}
            <PlusSvg className={styles.plusSvg} />
          </span>
        </h1>
      </div>
      <div className='flex margin-bottom-l'>
        <ProductNavigationLinks />
      </div>
    </>
  );
};
